/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeConfigInitRespVo } from './DeliverFeeConfigInitRespVo';
import {
    DeliverFeeConfigInitRespVoFromJSON,
    DeliverFeeConfigInitRespVoFromJSONTyped,
    DeliverFeeConfigInitRespVoToJSON,
    DeliverFeeConfigInitRespVoToJSONTyped,
} from './DeliverFeeConfigInitRespVo';

/**
 * 
 * @export
 * @interface ResponseDeliverFeeConfigInitRespVo
 */
export interface ResponseDeliverFeeConfigInitRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseDeliverFeeConfigInitRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseDeliverFeeConfigInitRespVo
     */
    message?: string;
    /**
     * 
     * @type {DeliverFeeConfigInitRespVo}
     * @memberof ResponseDeliverFeeConfigInitRespVo
     */
    data?: DeliverFeeConfigInitRespVo;
}

/**
 * Check if a given object implements the ResponseDeliverFeeConfigInitRespVo interface.
 */
export function instanceOfResponseDeliverFeeConfigInitRespVo(value: object): value is ResponseDeliverFeeConfigInitRespVo {
    return true;
}

export function ResponseDeliverFeeConfigInitRespVoFromJSON(json: any): ResponseDeliverFeeConfigInitRespVo {
    return ResponseDeliverFeeConfigInitRespVoFromJSONTyped(json, false);
}

export function ResponseDeliverFeeConfigInitRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseDeliverFeeConfigInitRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : DeliverFeeConfigInitRespVoFromJSON(json['data']),
    };
}

export function ResponseDeliverFeeConfigInitRespVoToJSON(json: any): ResponseDeliverFeeConfigInitRespVo {
    return ResponseDeliverFeeConfigInitRespVoToJSONTyped(json, false);
}

export function ResponseDeliverFeeConfigInitRespVoToJSONTyped(value?: ResponseDeliverFeeConfigInitRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': DeliverFeeConfigInitRespVoToJSON(value['data']),
    };
}

